<template>

  <div class="goods">
    <van-nav-bar
      title="服务工单详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"/>

    <van-tabs v-model="active">
      <van-tab title="服务项目">
        <servers :data="data" />
      </van-tab>
      <van-tab title="费用结账">
        <amt :data="data" />
      </van-tab>
      <van-tab title="服务图片">
        <images />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>

import { RepairServiceOrderApi } from '@/api/vip'
import servers from '@/view/repair/components/servers'
import amt from '@/view/repair/components/amt'
import images from '@/view/repair/components/images'
import { Toast } from 'vant';
import {
  Tabs,
  Tab,
  NavBar
} from 'vant';

export default {
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    servers,
    amt,
    images
  },

  data() {
    return {
      active: 0,
      id: this.$route.params.id,
      data: {
        account: null,
        agent: null,
        areashort: null,
        areashort_name: '',
        bill_date: '',
        bill_no: '',
        business_amount: '',
        car: null,
        car_category: '',
        car_code: '',
        car_damage: '',
        corp_vip: null,
        create_date: '',
        deduction_amount: '',
        deduction_id: null,
        delivery_date: '',
        deposit: '',
        description: null,
        driven_distance: '',
        guarantee: null,
        id: null,
        note: null,
        other_price: '',
        payee: null,
        phone: '',
        pickup: null,
        productitems: [],
        products_price: '',
        remaining_oil: null,
        repair_images: [],
        rev_Deduction_amount: null,
        rev_account: null,
        rev_account_name: '',
        rev_agent: null,
        rev_amount: '',
        rev_cash_amount: '',
        rev_date: '',
        sender: null,
        sender_phone: null,
        serviceitems: [],
        settle_date: '',
        settle_note: null,
        shop: null,
        state: null,
        state_name: '',
        storedvaluecard: null,
        storedvaluecard_amount: '',
        vip: null,
        vip_grade: '',
        vip_name: '',
        vip_number: '',
        work_price: ''
      }
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      this.axios.get(RepairServiceOrderApi + that.id + '/').then(function (ret) {
        if ('flag' in ret && !ret.flag) {
          Toast(ret.info)
        } else {
          that.data = ret
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    onClickLeft() {
      this.$router.back(-1)
    }
  }
};
</script>
